import { Button, Col, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { GreenRoundCheck, PassedOpportunityIcon } from '../../../../components/common/CustomIcon';
import JOB_ACTION_CARD_CONSTANT from '../../constants/jobconstants';

const JobCardMCA = (props) => {
  return (
    <div className="job-card-mca">
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.PASSEDTEST_NOTBOOKTI
        ? <CommonJobCard
          title="You are almost eligible for this job!"
          description={<span>Pass the Live Coding Challenge<br />to become eligible</span>}
          showButton
          btnTitle="Book your Live Coding Challenge"
          onClick={props.onBookTI}
          btnType="primary"
        />
        : null}
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.BOOKEDTI_FUTUREDATE
        ? <CommonJobCard
          title="You are almost eligible for this job!"
          description={<span>Pass the Live Coding Challenge<br />to become eligible</span>}
          showButton
          btnTitle={props.futureDate ? `Coding Challenge ${props.futureDate}` : null}
          btnType="primary"
          btnDisabled
        />
        : null}
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.BOOKEDTI_PASSED
        ? <CommonJobCard
          title="Are you interested?"
          description={<span>Click below to boost your<br />application for this job</span>}
          showButton
          btnTitle="🚀 Boost"
          onClick={() => props.onConsiderMe(props.jobId)}
          // btnIcon={<PanHandToolIcon width="18px" height="18px" />}
        />
        : null}
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.CONSIDERED
        ? <CommonJobCard
          title={<span>You are interested in this job</span>}
          description={<span>Stay tuned for updates<br />in your email inbox</span>}
          showIcon
          icon={<GreenRoundCheck height= "24px" width= "24px" />}
        />
        : null}
      {
        props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.SELF_PICKED
          ? <CommonJobCard
            title={<span>You were<br/>picked for this job!</span>}
            description={<span>Matched on {props.pickedDate ? props.pickedDate : 'N/A'}</span>}
            showIcon
            icon={<GreenRoundCheck style={{ width: '32px', height: '32px' }} />}
          />
          : null
      }
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.ANOTHER_PICKED
        ? <CommonJobCard
          title={<span>A Turing talent<br/>already got this job</span>}
          description={<span>Matched on {props.pickedDate ? props.pickedDate : 'N/A'}</span>}
          showIcon
          icon={<PassedOpportunityIcon height="32px" width="32px" />}
        />
        : null}
      {props.status && props.status.toLowerCase() === JOB_ACTION_CARD_CONSTANT.BOOKEDTI_FAILED
        ? <CommonJobCard
          description={<span>Unfortunately your Live Coding Challenge did not meet expectations. Please try again in 3 months.</span>}
        />
        : null}
    </div>
  );
};

const CommonJobCard = (props) => {
  return (
    <Row style={{ textAlign: 'center' }} className="job-common-card-mca">
      {
        props.showIcon ? <Col style={{ marginBottom: '12px' }}>{props.icon}</Col> : null
      }
      <Col><Typography.Text className="job-card-mca-title">{props.title}</Typography.Text></Col>
      <Col style={{ marginTop: '8px' }}><Typography.Text className="job-card-mca-description">{props.description}</Typography.Text></Col>
      {
        props.showButton
          ? (
            <Col style={{ marginTop: '16px' }}>
              {props.btnTitle ? <Button type={props.btnType} disabled={props.btnDisabled} onClick={props.onClick}>{props.btnIcon}{props.btnTitle}</Button> : null}
            </Col>
          )
          : null
      }
    </Row>
  );
};

CommonJobCard.propTypes = {
  showIcon: PropTypes.bool,
  showButton: PropTypes.bool,
  icon: PropTypes.any,
  title: PropTypes.any,
  description: PropTypes.any,
  btnType: PropTypes.string,
  btnTitle: PropTypes.string,
  btnDisabled: PropTypes.bool,
  btnIcon: PropTypes.any,
  onClick: PropTypes.func
};

JobCardMCA.propTypes = {
  status: PropTypes.string,
  onBookTI: PropTypes.func,
  pickedDate: PropTypes.string,
  onConsiderMe: PropTypes.func,
  jobId: PropTypes.number,
  futureDate: PropTypes.string
};

export default React.memo(JobCardMCA);
